import { addMinutes, differenceInMinutes, isAfter, isEqual } from "date-fns";
import { roundTimeByStep } from "./time";
import { getDeepCopy, isDeepEqual, uid } from "./helpers";
import { getLastDate, getRRULEConstByDate, parseRecurring, serializeRecurring, } from "./recurring";
export function saveForm(editorShape, dispatch, store, validation = () => false) {
    const { formValues, mode, prevValues, staticValues } = store.get();
    const event = {
        ...staticValues,
        recurringEventId: formValues.recurringEventId,
        id: formValues.id,
    };
    if (formValues.parent_id || prevValues.parent_id) {
        event.parent_id = formValues.parent_id;
    }
    if (!store.isChanged())
        return true;
    editorShape.forEach(field => {
        const { type, key } = field;
        const val = formValues[key];
        if (type === "date" && field.time) {
            const date = val;
            const time = formValues[`${key}_time`];
            date.setHours(time.getHours(), time.getMinutes());
            formValues[key] = date;
        }
        if (type === "recurring") {
            const { freq } = formValues.RRULE;
            if (freq === "NEVER" ||
                typeof val === null ||
                typeof val === undefined) {
                event.STDATE = null;
                event.RRULE = null;
                event.DTEND = null;
                event.recurring = false;
            }
            else {
                event.recurring = true;
                event.STDATE = event.start_date;
                event.RRULE = serializeRecurring(formValues.RRULE);
                event.DTEND = getLastDate(formValues.RRULE, event);
            }
        }
        else {
            event[key] = val;
        }
    });
    const saveError = preSaveValidationError(event) || validation(event);
    if (saveError) {
        dispatch("alert", {
            message: saveError,
        });
        return false;
    }
    if ((prevValues.recurring !== event.recurring || !event.recurring) &&
        !`${event.id}`.includes("wx_recurring") &&
        !event.recurringEventId) {
        dispatch("action", {
            action: `${mode}-event`,
            data: {
                event,
                id: formValues.id,
            },
        });
    }
    else {
        dispatch("recurringAction", {
            action: `${mode}-event`,
            data: {
                event,
                id: formValues.id,
                initEvent: prevValues,
            },
        });
    }
    store.set({
        mode: "update",
        prevValues: getDeepCopy(formValues),
    });
    return true;
}
export function setDefaults(config) {
    const { event, editorShape, mode, defaultEventDuration, store, currentDate, setter, locale, timeStep = 1, } = config;
    const copy = getDeepCopy({ ...event });
    const today = new Date();
    currentDate.setHours(today.getHours(), today.getMinutes());
    const editorKeys = [];
    editorShape.forEach(f => {
        const { type, key, label } = f;
        editorKeys.push(key);
        if (typeof copy[key] === "undefined") {
            let val;
            switch (type) {
                case "files":
                    val = [];
                    break;
                case "date":
                    val = roundTimeByStep(key !== "end_date"
                        ? currentDate
                        : addMinutes(copy["start_date"], defaultEventDuration), timeStep);
                    break;
                case "text":
                    val = label || "";
                    break;
                case "checkbox":
                    val = false;
                    break;
                case "colorSchema":
                    val = {};
                    break;
                case "recurring":
                    val = false;
                    break;
                default:
                    val = "";
            }
            copy[key] = val;
        }
        if (type === "multiselect" && copy[key].length) {
            copy[key] = copy[key].map((i) => typeof i === "object" ? i.id : i);
        }
        if (type === "date" && f.time) {
            copy[`${key}_time`] = new Date(copy[key]);
        }
        if (type === "files" && !(copy[key] instanceof Array)) {
            copy[key] = [copy[key]];
        }
        if (type === "recurring") {
            const _dates = locale.getRaw().dateFnsLocale;
            copy.RRULE = {
                ...parseRecurring(copy.RRULE, copy, _dates),
            };
        }
    });
    if (mode === "add") {
        copy.id = copy.id ?? uid();
        const staticValues = {};
        Object.keys(event).forEach(key => {
            if (!editorKeys.includes(key)) {
                staticValues[key] = event[key];
            }
        });
        store.set({ mode, formValues: copy, staticValues });
        setter(copy);
    }
    else {
        store.set({
            mode,
            formValues: copy,
            prevValues: getDeepCopy(copy),
        });
    }
    return copy;
}
export class EditorStore {
    constructor(s) {
        this._observers = [];
        this._state = {
            formValues: {},
            prevValues: {},
            mode: "update",
            showEditor: false,
            defaultEventDuration: 5,
            disabledTimepicker: false,
            staticValues: {},
        };
        this._state = {
            ...this._state,
            ...s,
        };
    }
    subscribe(observer) {
        this._observers.push(observer);
        this.set(this._state);
        return () => this.unsubscribe(observer);
    }
    unsubscribe(observer) {
        this._observers = this._observers.filter(ob => ob !== observer);
    }
    set(state) {
        this._state = { ...this._state, ...state };
        this._observers.forEach(ob => {
            ob(this._state);
        });
    }
    isChanged() {
        const { formValues, prevValues } = this._state;
        return !prevValues || !isDeepEqual(formValues, prevValues);
    }
    get() {
        return this._state;
    }
}
export function validateForm(config) {
    const { values, defaultEventDuration, formState, store } = config;
    let validation = {};
    const { start_date_time: prev_start_date_time, end_date: prev_end_date, end_date_time: prev_end_date_time, start_date: prev_start_date, } = formState.get().prevValues;
    const { start_date_time, start_date, RRULE } = values;
    if (values.start_date && values.end_date) {
        let { end_date, end_date_time } = values;
        if (start_date_time && start_date_time) {
            start_date.setHours(start_date_time.getHours(), start_date_time.getMinutes());
        }
        if (prev_start_date && prev_end_date_time) {
            prev_start_date.setHours(prev_start_date_time.getHours(), prev_start_date_time.getMinutes());
        }
        if (prev_end_date && prev_end_date_time) {
            prev_end_date.setHours(prev_end_date_time.getHours(), prev_end_date_time.getMinutes());
        }
        if (end_date_time && end_date_time) {
            end_date.setHours(end_date_time.getHours(), end_date_time.getMinutes());
        }
        if (prev_start_date &&
            prev_start_date.valueOf() !== start_date.valueOf() &&
            prev_end_date.valueOf() === end_date.valueOf()) {
            const diff = differenceInMinutes(prev_end_date, prev_start_date);
            end_date = addMinutes(start_date, diff);
            end_date_time = new Date(end_date);
        }
        if (start_date > end_date) {
            end_date = addMinutes(start_date, defaultEventDuration);
            end_date_time = new Date(end_date);
        }
        validation = {
            end_date,
            end_date_time,
        };
    }
    const validValues = {
        ...values,
        ...validation,
    };
    if (RRULE &&
        typeof RRULE === "object" &&
        prev_start_date &&
        !isEqual(prev_start_date, start_date)) {
        validValues.RRULE = { ...RRULE, ...getRRULEConstByDate(start_date) };
    }
    formState.set({
        formValues: getDeepCopy(validValues),
        disabledTimepicker: values.allDay,
    });
    store.reset(validValues);
}
export function preSaveValidationError(values) {
    const { RRULE, start_date } = values;
    if (RRULE) {
        const { UNTIL } = parseRecurring(RRULE, values);
        if (isAfter(start_date, UNTIL))
            return "recurringActionError";
    }
    return false;
}
//# sourceMappingURL=editor.js.map